import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutReasonItem } from '../../about.models';

@Component({
  selector: 'app-about-why-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-why-section.component.html',
  styleUrl: './about-why-section.component.scss'
})
export class AboutWhySectionComponent {
  @Input({ required: true }) reasons: AboutReasonItem[] = [];
}
